import { SharedModule } from './shared/shared.module';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Language } from './shared/constants/language.enum';

import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit {
  public loadingText = '';

  constructor(private readonly translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.setDefaultLang(Language.PT);
    this.translate.use(Language.PT);
    this.setLoadingText();
  }

  public setLoadingText(): void {
    const language = localStorage.getItem('lang') ?? Language.PT;
    switch (language){
      case Language.EN:
        this.loadingText = 'Please, wait...'
        break
      case Language.PT:
      default:
        this.loadingText = 'Por favor, aguarde...'
        break
      case Language.ES:
        this.loadingText = 'Espere, por favor...'
        break
    }
  }
}
